import React from 'react';
import { UserCog, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/app/providers';
import { Button } from '@/components/ui';

const ImpersonationBanner: React.FC = () => {
  const { t } = useTranslation();
  const { isImpersonating, currentUser, stopImpersonation, impersonation } = useAuth();
  const [isStopping, setIsStopping] = React.useState(false);

  if (!isImpersonating || !currentUser) {
    return null;
  }

  const handleStop = async () => {
    setIsStopping(true);
    try {
      await stopImpersonation();
    } finally {
      setIsStopping(false);
    }
  };

  return (
    <div className="bg-warning text-warning-foreground shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 min-w-0">
          <UserCog className="w-4 h-4 flex-shrink-0" />
          <span className="text-sm font-medium truncate">
            {t('impersonation.banner', {
              email: currentUser.email,
              superAdmin: impersonation.impersonatedByEmail || t('impersonation.unknownSuperAdmin'),
            })}
          </span>
        </div>
        <Button
          variant="secondary"
          size="sm"
          onClick={handleStop}
          disabled={isStopping}
          leftIcon={<X className="w-3.5 h-3.5" />}
          className="flex-shrink-0 bg-white/90 hover:bg-white text-foreground border-0"
        >
          {isStopping ? t('impersonation.stopping') : t('impersonation.stop')}
        </Button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
